import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useTranslation } from "react-i18next";
import { Brand } from "../components/Brand";
import { LanguageMenu } from "../components/LanguageMenu";
import { ALTO_PANTALLA } from "../theme/theme";

const SECTIONS = [1, 2, 3, 4];

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <Box sx={{ minHeight: ALTO_PANTALLA, bgcolor: "background.default" }}>
      <Box
        component="header"
        sx={{
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "background.paper",
          py: 2,
        }}
      >
        <Container maxWidth="md">
          <Stack
            direction="row"
            sx={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <Brand />
            <Stack direction="row" spacing={1.5} sx={{ alignItems: "center" }}>
              <LanguageMenu />
              <Button
                component={RouterLink}
                to="/"
                variant="outlined"
                startIcon={<ChevronLeftIcon />}
              >
                {t("common.back")}
              </Button>
            </Stack>
          </Stack>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
        <Typography variant="h1">{t("privacy.title")}</Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mt: 1, mb: 4 }}
        >
          {t("privacy.subtitle")}
        </Typography>

        <Stack spacing={2.5}>
          {SECTIONS.map((index) => (
            <Card key={index} sx={{ p: 3 }}>
              <Typography variant="h3" sx={{ mb: 1 }}>
                {t(`privacy.section${index}Title`)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t(`privacy.section${index}Text`)}
              </Typography>
            </Card>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
